import { BaseDialog, BaseRadioGroup, BaseTextarea } from '@/shared/components'
import { useState } from 'react'

type Props = {
  isOpen: boolean
  onClose: () => void
  onAction: (data: { withdrawId: string; traderReason: string }) => void
  onStepBack: () => void
  withdrawId: string
  isLoading: boolean
}

export const CancelPayoutDialog = ({
  isOpen,
  onAction,
  onClose,
  onStepBack,
  withdrawId,
  isLoading,
}: Props) => {
  const [selectedOption, setSelectedOption] = useState('')
  const [customReason, setCustomReason] = useState('')
  const [error, setError] = useState('')

  const options = [
    { name: 'Высокий риск мошенничества', value: 'fraud_risk' },
    { name: 'Неверный получатель', value: 'incorrect_recipient' },
    { name: 'У меня заблокировали личный кабинет', value: 'blocked_account' },
    { name: 'Все мои ЛК в блоке (открепить все заявки в работе)', value: 'cancel_all_orders' },
    { name: 'Другая причина', value: 'another_reason' },
  ]

  const getReadableReason = () => {
    if (selectedOption === 'another_reason') {
      return customReason.trim()
    }
    const option = options.find((o) => o.value === selectedOption)
    return option ? option.name : ''
  }

  const handleAction = () => {
    if (selectedOption === 'another_reason') {
      if (!customReason.trim()) {
        setError('Укажите причину для открепления')
        return
      }
    } else {
      if (!selectedOption) {
        setError('Пожалуйста, выберите причину для открепления заявки.')
        return
      }
    }

    setError('')
    const reason = getReadableReason()
    onAction({ withdrawId, traderReason: reason })
  }

  const onOptionChange = (value: string) => {
    setSelectedOption(value)
    setError('') // сброс ошибки при выборе новой опции
  }

  const onCustomReasonChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCustomReason(e.target.value)
    setError('') // сброс ошибки при вводе текста
  }

  return (
    <BaseDialog
      isVisible={isOpen}
      onClose={onClose}
      onStepBack={onStepBack}
      closeButton
      onAction={handleAction}
      actionButtonName="Открепить заявку"
      actionButtonVariant="red"
      closeButtonName="Вернуться назад"
      title="Хотите открепить заявку?"
      isLoading={isLoading}
    >
      <div className="flex flex-col gap-4">
        <p>Выберите причину:</p>
        <BaseRadioGroup value={selectedOption} onChange={onOptionChange} options={options} />
        {selectedOption === 'another_reason' && (
          <BaseTextarea
            placeholder="Укажите причину для открепления"
            size="sm"
            value={customReason}
            onChange={onCustomReasonChange}
          />
        )}
        {error && <p className="text-error text-sm">{error}</p>}
      </div>
    </BaseDialog>
  )
}
